<template>
  <mdb-container class="gp-has-header">
    <h4 class="text-left">
      <mdb-icon color="primary" icon="question"/>
      Help Messages
    </h4>
    <div v-if="showList">
      <mdb-card>
        <mdb-card-header class="text-left" v-if="!query">
          <mdb-btn @click="showFilters=!showFilters" icon="filter" rounded size="sm">Filters</mdb-btn>
          Current Filter: {{filterDisplay}}
        </mdb-card-header>
        <mdb-card-body v-if="showFilters">
          <span :key="i" v-for="(f,i) in filters">
            <mdb-btn :color="f.value==filter ? 'success' : 'primary'" @click="showFilter(f.value)" rounded size="sm">{{f.label}}</mdb-btn>
          </span>
        </mdb-card-body>
      </mdb-card>
      <mdb-input @input="isTyping = true"
                 placeholder="Find a Message" type="text" v-model="query"
      />
      <mdb-tbl class="text-left" responsive striped v-if="messages.length>0">
        <mdb-tbl-head class="primary-color text-white">
          <tr>
            <th>Date</th>
            <th>Sender</th>
            <th>Subject</th>
            <th>Viewed</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr :id="'message-'+m.id" :key="m.id" @click="viewMessage(m)" class="clickable" v-for="m in messages">
            <td>{{m.date}}</td>
            <td>{{m.sender}}</td>
            <td>{{m.subject}}</td>
            <td>
              <mdb-icon icon="check" v-if="m.viewed"/>
            </td>
          </tr>

        </mdb-tbl-body>
      </mdb-tbl>
    </div>
    <div class="text-left" v-if="showMessage">
      <mdb-card class="mb-4">
        <mdb-card-header>
          <h5>{{currentMessage.subject}} from {{currentMessage.sender}}</h5>
          <mdb-btn @click="messageList" icon="arrow-left" rounded size="sm"/>
          <mdb-btn @click="toggleViewed" icon="eye" v-if="!currentMessage.viewed" rounded size="sm">Mark Viewed</mdb-btn>
          <mdb-btn @click="toggleViewed" icon="eye-slash" v-if="currentMessage.viewed" rounded size="sm">Mark Unread</mdb-btn>
          <mdb-btn @click="deleteModal=true" icon="trash" color="danger" rounded size="sm">Delete</mdb-btn>
          <mdb-btn @click="replyModal=true" icon="envelope" color="warning" rounded size="sm">Reply</mdb-btn>
        </mdb-card-header>
        <mdb-card-body>
          <div v-html="currentMessage.htmlBody"></div>
          <mdb-btn @click="showPlainText = !showPlainText" rounded size="sm">Toggle Plain Text</mdb-btn>
          <div v-if="showPlainText">
            {{currentMessage.plainBody}}
          </div>
        </mdb-card-body>
        <mdb-card-footer>
          <div><h6>Created on {{currentMessage.date}} </h6>
            <mdb-badge v-if="currentMessage.replies==0">No Replies</mdb-badge>
            <mdb-btn @click="getReplies" v-if="currentMessage.replies > 0 && replies.length==0">Show Replies ({{currentMessage.replies}})
            </mdb-btn>
          </div>
        </mdb-card-footer>
      </mdb-card>
      <div v-if="replies.length>0">
        <h5>Replies</h5>
        <mdb-card v-for="(reply,i) in replies" class="mb-4" :key="i">
          <mdb-card-header>
            <h5>Reply at {{reply.date}}</h5>
          </mdb-card-header>
          <mdb-card-body>
            <div v-html="reply.response"></div>
          </mdb-card-body>
        </mdb-card>
      </div>
    </div>

    <yes-no-modal @no="deleteModal = false"
                  @yes="doDelete"
                  question="Are you sure?."
                  v-if="deleteModal"/>

    <mdb-modal @close="replyModal=false" v-if="replyModal">
      <mdb-modal-header :close="true">
        Reply
      </mdb-modal-header>
      <mdb-modal-body>
        <editor :init="editorConfig" v-model="replyText">
        </editor>
        <mdb-btn @click="sendReply">
          <mdb-icon icon="envelope"/>
          Send
        </mdb-btn>
        <mdb-btn @click="replyModal=false">
          <mdb-icon icon="window-close"/>
          Cancel
        </mdb-btn>
      </mdb-modal-body>
    </mdb-modal>


  </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi'
import UserContent from "./common/UserContent";
import gpSelect from "./common/GPSelect";
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbMasonry,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbPanel,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import editor from '@tinymce/tinymce-vue'
import YesNoModal from "./common/YesNoModal";

export default {
    name: 'HelpMessages',
    components: {
      mdbBtn,
      mdbContainer,
      mdbBadge,
      mdbIcon,
      mdbTbl,
      mdbTblHead,
      mdbTblBody,
      mdbPanel,
      mdbChip,
      mdbMasonry,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbCardFooter,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbModalFooter,
      mdbRow,
      mdbCol,
      mdbInput,
      UserContent,
      gpSelect,
      editor,
      YesNoModal
    },
    computed: {
      filterDisplay: function () {
        for (let i = 0; i < this.filters.length; i++) {
          if (this.filter == this.filters[i].value) return this.filters[i].label
        }
        return ""
      }
    },
    data() {
      return {
        messages: [],
        replies: [],
        query: "",
        totalMessages: 0,
        showPlainText: false,
        showList: true,
        showMessage: false,
        currentMessage: null,
        isTyping: false,
        scrollEvent: null,
        listScrollPos: 0,
        filter: "unviewed",
        showFilters: false,
        isAdmin: false,
        showCreate: false,
        newMessage: {},
        showStats: false,
        stats: [],
        deleteModal: false,
        replyModal: false,
        replyText: "",
        editorConfig: {
          browser_spellcheck: true,
          branding: false,
          plugins: ["image", "link", "code", "paste", "table", "lists"],
          toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | styleselect | image link unlink code "],
          image_advtab: true,
          style_formats_merge: true,
          paste_as_text: true,
          paste_data_images: true,
          relative_urls: false,
          remove_script_host: false,
          height: 400,
          style_formats: [{
            title: 'Image Left',
            selector: 'img',
            styles: {
              'float': 'left',
              'margin': '0 10px 0 10px'
            }
          },
            {
              title: 'Image Right',
              selector: 'img',
              styles: {
                'float': 'right',
                'margin': '0 0 10px 10px'
              }
            },
            {
              title: 'GP Heading',
              block: 'div',
              classes: 'tile_title'
            }
          ]
        },
        filters: [{label: "Not Viewed", value: "unviewed"},
          {label: "Viewed", value: "viewed"},
          {label: "No Replies", value: "noreply"},
          {label: "All", value: "all"}
        ]
      };

    },
    watch: {
      query: _.debounce(function () {
        this.isTyping = false;
      }, 300),
      isTyping: function (value) {
        if (!value) {
          this.loadMessages()
        }
      }
    },
    mounted() {
      if (this.$route.params.id) {
        this.filter = "id"
      }
      this.loadMessages(false)
      window.addEventListener("scroll", this.scrollListener)
      document.title = "Messages";
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.scrollListener)
    },
    methods: {
      saveMessage() {
        this.$store.dispatch("setExecuting", true)
        let url = "/helpMessage/list/" + this.currentIssue.id
        api.post(url, this.currentIssue).then(
          (results) => {
            this.currentIssue.statusDate = results.data.statusDate
            this.$notify.success({message: "Updated Successfully", timeOut: 3000})
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 6000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      showFilter: function (f) {
        this.filter = f
        this.loadMessages(false)
      },
      loadMessages: function (loadMore) {
        let offset = 0
        if (!loadMore) this.messages = []
        else {
          offset = this.messages.length
          if (offset == this.totalMessages) return
        }
        this.$store.dispatch("setExecuting", true)
        let url = "/helpMessage/list/?offset=" + offset + "&filter=" + this.filter
        if (this.query) url += "&q=" + this.query
        if (this.filter == "id") url += "&id=" + this.$route.params.id
        api.get(url).then(
          (results) => {
            if (loadMore) {
              for (let i = 0; i < results.data.messages.length; i++) {
                this.messages.push(results.data.messages[i])
              }
            } else {
              this.messages = results.data.messages
              if (this.filter == "id" && this.messages.length == 1) {
                this.viewMessage(this.messages[0])
              }
            }
            this.totalMessages = results.data.totalCount
          },
          (error) => {
            if (error.response.status == 403 || error.response.status == 401) this.$router.push("/403")
            else this.$notify.error({message: error.response.data, timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },

      getReplies: function () {
        this.$store.dispatch("setExecuting", true)
        let url = "/helpMessage/replies/" + this.currentMessage.id
        api.get(url).then(
          (results) => {
            this.replies = results.data
          },
          (error) => {
            if (error.response.status == 403 || error.response.status == 401) this.$router.push("/403")
            else this.$notify.error({message: error.response.data, timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      toggleViewed: function () {
        this.$store.dispatch("setExecuting", true)
        let url = "/helpMessage/toggleViewed/" + this.currentMessage.id
        api.post(url,{}).then(
          (results) => {
            this.currentMessage.viewed = !this.currentMessage.viewed
          },
          (error) => {
            if (error.response.status == 403 || error.response.status == 401) this.$router.push("/403")
            else this.$notify.error({message: error.response.data, timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      doDelete: function () {
        this.deleteModal=false
        this.$store.dispatch("setExecuting", true)
        let url = "/helpMessage/delete/" + this.currentMessage.id
        api.delete(url).then(
          (results) => {
            let loc = this.messages.indexOf(this.currentMessage)
            this.messages.splice(loc,1)
            this.messageList()
          },
          (error) => {
            if (error.response.status == 403 || error.response.status == 401) this.$router.push("/403")
            else this.$notify.error({message: error.response.data, timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      sendReply: function () {
        this.replyModal=false
        this.$store.dispatch("setExecuting", true)
        let url = "/helpMessage/reply/" + this.currentMessage.id
        api.post(url,{replyText: this.replyText}).then(
          (results) => {
            this.replyText = ""
            this.replies.unshift(results.data)
            this.showReplies = true
          },
          (error) => {
            this.replyModal=true
            if (error.response.status == 403 || error.response.status == 401) this.$router.push("/403")
            else this.$notify.error({message: error.response.data, timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      scrollListener() {
        if (!this.showList) return
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
        if (bottomOfWindow && this.totalMessages > this.messages.length) {
          this.loadMessages(true)
        }

      },
      refresh: function () {
        this.loadMessages(false)
      }
      ,
      viewMessage: function (i) {
        this.replies = []
        this.currentMessage = i
        this.showList = false
        this.showMessage = true
        let el = document.getElementById("message-" + i.id)
        if (el) this.listScrollPos = el.offsetTop - 40
        this.$nextTick().then(() => {
          window.scrollTo(0, 0)
        })
      }
      ,
      messageList: function () {
        if (this.filter == "id") {
          window.location = "/admin/help"
          return
        }
        this.currentMessage = null
        this.showList = true
        this.showMessage = false
        this.$nextTick().then(() => {
          window.scrollTo(0, this.listScrollPos)
        })
      }

    }
    ,
  }
  ;
</script>

<style scoped>
  .clickable {
    cursor: pointer;
  }
</style>
